import { FILE_SCOPE_EMAIL } from '../../../../../constants/file'
import { useScreen } from '../../../../../hooks'
import { getImageFilePreview } from '../../../../../utils/file'
import { FileList, FileListDownloadAll, FilePreview } from '../../../../File'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../../../FilesPreviewGallery'

import * as styles from './AttachedFiles.module.css'

function AttachedFiles({ files, scope = FILE_SCOPE_EMAIL, subject }) {
  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files })

  const { isMobileScreenSize } = useScreen()

  function renderFile(file, key) {
    return (
      <FilePreview
        allowRemove={false}
        file={file}
        getImageSrc={getImageFilePreview}
        key={key}
        onClick={handleClickFile}
      />
    )
  }

  return files?.length > 0 ? (
    <>
      <FileListDownloadAll
        className={styles.downloadAll}
        downloadButtonProps={{
          text: !isMobileScreenSize
            ? 'FilesGallery.DownloadAttachedFilesBtnKey'
            : null,
        }}
        files={files}
      />
      <FileList
        className={styles.fileList}
        files={files}
        itemClassName={styles.fileListItem}
        renderItem={renderFile}
      />
      <FilesPreviewGallery
        files={files}
        initActive={activeFileIndex}
        scope={scope}
        subject={subject}
        onClose={handleCloseFilePreview}
      />
    </>
  ) : null
}

export default AttachedFiles
